import React from 'react';
import styled from 'styled-components/macro';

import ToolbarOptions from './ToolbarOptions';
import { useComposition, useWorkspace } from '../../context';
import ScrollHorizontalContainer from '../common/ScrollHorizontalContainer';

const Wrapper = styled.section`
    background-color: white;
    display: flex;
    flex-direction: row;
    // justify-content: center;
    width: inherit;
    max-width: 100%;
    pointer-events: auto;
    padding-top: 8px;
    padding-bottom: 4px;
`;

const MobileWorkspaceTools = ({ showTools }) => {
    const { activeFrame } = useComposition();
    const { dotsSection } = useWorkspace();

    return (
        <ScrollHorizontalContainer padding={'0px'}>
            <Wrapper $showTools={showTools} $activeFrame={activeFrame} $dotsSection={dotsSection}>
                <ToolbarOptions />
            </Wrapper>
        </ScrollHorizontalContainer>
    );
};

export default MobileWorkspaceTools;
